import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EASE = [0.22, 1, 0.36, 1];

const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="testimonials" className="relative py-28 lg:py-36" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="font-mono2 text-xs sm:text-sm uppercase tracking-[0.25em] text-amber-600 mb-5"
        >
          Chapter 03 / Alumni Stories
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight mb-16 max-w-2xl"
        >
          Hear It from the Alumni.
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <motion.figure
              key={t.author}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.1 }}
              className={`rounded-3xl border border-slate-200 bg-[#F8FAFC] p-8 flex flex-col hover:border-amber-400/30 transition-colors duration-500 ${i === 1 ? "md:-translate-y-6" : ""}`}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote size={22} className="text-amber-600 mb-5" />
              <blockquote className="text-sm text-slate-700 leading-relaxed flex-1">“{t.quote}”</blockquote>
              <figcaption className="mt-7 pt-5 border-t border-slate-200">
                <div className="font-display font-bold text-sm">{t.author}</div>
                <div className="font-mono2 text-[10px] uppercase tracking-wider text-slate-500 mt-1">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
